"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeAddressValidation = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
class AnnualHomeAddressValidation extends journey_services_1.ValidationMethodBase {
    constructor(props) {
        super();
        this.props = props;
        if (!this.props.interactionField) {
            throw Error("AnnualHomeAddressValidation missing interactionField attribute");
        }
        if (!this.props.unquotablePostCodes) {
            throw Error("AnnualHomeAddressValidation missing unquotablePostCodes attribute");
        }
        if (!this.props.unquotableAggregatorPostCodes) {
            throw Error("AnnualHomeAddressValidation missing unquotableAggregatorPostCodes attribute");
        }
    }
    validateInput(input, context) {
        const pageContext = context;
        if (pageContext.engine) {
            const interaction = pageContext.engine.getInteraction();
            const uiState = journey_services_1.ObjectManipulator.fetchFieldValue("uistate", interaction);
            const isFromAggregator = interaction.source && interaction.source !== "";
            const postCode = journey_services_1.ObjectManipulator.fetchFieldValue(this.props.interactionField, interaction);
            if ((isFromAggregator && this.props.unquotableAggregatorPostCodes.some(code => postCode.startsWith(code)))
                || (!isFromAggregator && this.props.unquotablePostCodes.some(code => postCode.startsWith(code)))) {
                uiState.quotablePostCode = false;
                return this.invalidResult(journey_services_1.ExpressionEvaluator.renderTemplate(this.props.unquotablePostCodeErrorMsg, interaction));
            }
            if (input == null) {
                return this.invalidResult("Please select an address to continue");
            }
            uiState.quotablePostCode = true;
        }
        return this.validResult();
    }
}
exports.AnnualHomeAddressValidation = AnnualHomeAddressValidation;
//# sourceMappingURL=AnnualHomeAddressValidation.js.map